module.exports = __webpack_public_path__ + "static/media/MarkPro-Medium.778904b7.woff2";